import { Dispatch } from 'redux'
import { AnyAction } from 'redux-saga'
import { NavigateFunction } from 'react-router-dom'

import { BridgeService } from '@services/bridge'
import { refinancingBeginRequest, contratosRequest } from '@store/refinanciamento/contratos/actions'
import { showError } from '@store/ui/error/actions'
import { ErrorCodes } from '@utils/enums'
import routesV2 from '@routes/routes'

const parseIsApp = (value?: string) => {
  if (!value) return null
  const normalized = value.toLowerCase()
  if (normalized === 'true' || normalized === '1' || normalized === 'app' || normalized === 'isapp')
    return true
  if (normalized === 'false' || normalized === '0' || normalized === 'site' || normalized === 'web')
    return false
  return null
}

const getUtmSourceFromParams = (params: qs.ParsedQs) => {
  if (params?.utm_source) return params.utm_source.toString()
  if (params?.utmSource) return params.utmSource.toString()
  return ''
}

const getUtmMediumFromParams = (params: qs.ParsedQs) => {
  if (params?.utm_medium) return params.utm_medium.toString()
  if (params?.utmMedium) return params.utmMedium.toString()
  if (params?.utmSMedium) return params.utmSMedium.toString()
  return ''
}

const getUtmCampaignFromParams = (params: qs.ParsedQs) => {
  if (params?.utm_campaign) return params.utm_campaign.toString()
  if (params?.utmCampaign) return params.utmCampaign.toString()
  if (params?.utmSCampaign) return params.utmSCampaign.toString()
  return ''
}

const getUtmContentFromParams = (params: qs.ParsedQs) => {
  if (params?.utm_content) return params.utm_content.toString()
  if (params?.utmContent) return params.utmContent.toString()
  if (params?.utmSContent) return params.utmSContent.toString()
  return ''
}

const handleRefinancingBegin = (dispatch: Dispatch<AnyAction>, navigate: NavigateFunction) => {
  dispatch(
    refinancingBeginRequest({
      successCallback: () => {
        BridgeService.tic({
          name: 'btn_buscar_contratos',
          action: 'buscar_contratos',
        })

        dispatch(
          contratosRequest({
            semContratosCallback: () => {
              navigate(routesV2.SEM_EMPRESTIMO, {
                state: { step: 'listagem-contratos' },
              })
            },
            successCallback: () => {
              navigate(routesV2.CONTRATOS)
            },
          }),
        )
      },
      errorCallback: () => {
        dispatch(
          showError({
            title: 'Erro ao iniciar refinanciamento',
            message: 'Ocorreu um erro ao iniciar o processo de refinanciamento. Tente novamente.',
            actionTitle: 'Tentar Novamente',
            code: ErrorCodes.RE_001_CONTRATOS,
            functionCallback: () => {
              window.location.reload()
            },
          }),
        )
      },
    }),
  )
}

export {
  parseIsApp,
  getUtmSourceFromParams,
  getUtmMediumFromParams,
  getUtmCampaignFromParams,
  getUtmContentFromParams,
  handleRefinancingBegin,
}
